var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoMusicalNote = function SvgNoMusicalNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21.22 11.688V2.303a1 1 0 0 0-1.26-.966L9.08 4.253a1 1 0 0 0-.742.966V8m12.882 3.688v3.772a2 2 0 0 1-1.49 1.933l-1.585.42m3.075-6.125-4.67 1.257a2 2 0 0 0-1.48 1.931v.108m-6.732.172-4.66 1.232A2 2 0 0 0 2.19 18.32v1.159A2 2 0 0 0 4.7 21.413l2.15-.567a2 2 0 0 0 1.488-1.934zm0 0V13M3 3l18 18"
  })));
};
export default SvgNoMusicalNote;